import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const TelecallerjobsFbd = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`Telecaller Jobs in Faridabad | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest telecaller jobs in Faridabad NCR. Apply for voice process, customer support, and BPO telecalling jobs in top companies hiring freshers and experienced candidates."
        />
        <meta
          name="keywords"
          content="telecaller jobs in Faridabad, telecalling jobs in Faridabad NCR, BPO jobs in Faridabad, call center jobs Faridabad, customer care executive jobs Faridabad, voice process jobs Faridabad, inbound outbound telecaller jobs Faridabad, part-time telecaller jobs Faridabad"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsinFaridabadncr.in/telecaller-jobs-in-faridabad"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Telecaller Jobs in Faridabad – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Looking for <strong>telecaller jobs in Faridabad</strong>? Explore hundreds
          of openings in BPOs, call centers, and customer support departments.
          Whether you are a fresher or experienced, find <strong>voice process</strong> and{" "}
          <strong>non-voice process</strong> jobs in Faridabad NCR today.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring Telecallers in Faridabad
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Concentrix</li>
          <li>Teleperformance</li>
          <li>Genpact</li>
          <li>WNS Global Services</li>
          <li>Hinduja Global Solutions</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Available Job Categories
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Inbound Telecaller Jobs in Faridabad</li>
          <li>Outbound Telecaller Jobs in Faridabad</li>
          <li>Customer Support Executive Jobs in Faridabad</li>
          <li>Voice Process Jobs in Faridabad</li>
          <li>Non-Voice Process Jobs in Faridabad</li>
          <li>Sales Telecaller Jobs in Faridabad</li>
          <li>BPO Jobs in Faridabad</li>
          <li>Call Center Jobs in Faridabad</li>
          <li>Part-time Telecaller Jobs in Faridabad</li>
          <li>Work From Home Telecaller Jobs</li>
        </ul>

        <p className="text-gray-600">
          Apply online through{" "}
          <strong>jobsindelhincr.in</strong> — your trusted platform to find
          verified <strong>telecaller job openings</strong> in Faridabad NCR. No
          registration required — connect directly with employers hiring now!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default TelecallerjobsFbd;
